module.exports = __webpack_public_path__ + "static/media/19ESCAP28.357a19be.jpg";